(function () {
  'use strict';

  // Slider: 0 = Lille (runs small), 10 = Stor (runs large)
  var FIT_THRESHOLDS = { smallMax: 3, largeMin: 7 };

  var overlay, modal, recBox, recText, keepBtns, continueBtn, closeBtn;
  var activeDismissKey = null;
  var detecting = false;
  var isInjected = false;

  function getFitMessage(trueToSize) {
    if (trueToSize === null || trueToSize === undefined) return null;
    var val = Number(trueToSize);
    if (val <= FIT_THRESHOLDS.smallMax) {
      return 'Produktet er lille i størrelsen. Vi anbefaler, at du går en størrelse op.';
    }
    if (val >= FIT_THRESHOLDS.largeMin) {
      return 'Produktet er stort i størrelsen. Vi anbefaler, at du går en størrelse ned.';
    }
    return 'Produktet er normalt i størrelsen. Vi anbefaler, at du går med din normale størrelse.';
  }

  function getProductData() {
    var el = document.getElementById('fit-advisor-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function dismissKey(productId, variantIds) {
    return 'fitAdvisor:' + productId + ':' + variantIds.slice().sort().join(',');
  }

  function openModal() {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeDismissKey = null;
  }

  function populateModal(items, trueToSize) {
    var fitMsg = getFitMessage(trueToSize);

    if (fitMsg) {
      recText.textContent = fitMsg;
      recBox.removeAttribute('hidden');
    } else {
      recBox.setAttribute('hidden', '');
    }

    var removeKeys = items.map(function (i) { return i.key; });

    items.forEach(function (item, idx) {
      var imgEl = document.getElementById('fit-advisor-img-' + idx);
      var sizeEl = document.getElementById('fit-advisor-size-' + idx);
      var keepBtn = document.getElementById('fit-advisor-keep-' + idx);
      var card = document.getElementById('fit-advisor-card-' + idx);

      var imageUrl = item.image || '';
      if (imageUrl && imageUrl.indexOf('?') === -1) {
        imageUrl += '?width=240';
      } else if (imageUrl) {
        imageUrl += '&width=240';
      }
      imgEl.removeAttribute('src');
      imgEl.src = imageUrl;
      imgEl.alt = item.product_title || '';
      sizeEl.textContent = item.variant_title || item.title || '';
      keepBtn.dataset.keepKey = item.key;

      card.onclick = function () {
        var keepKey = keepBtn.dataset.keepKey;
        var removeKey = removeKeys.find(function (k) { return k !== keepKey; });
        handleKeepOnly(keepKey, removeKey);
      };
    });
  }

  function preloadImages(items, callback) {
    var urls = items.map(function (item) {
      var url = item.image || '';
      if (url && url.indexOf('?') === -1) url += '?width=240';
      else if (url) url += '&width=240';
      return url;
    }).filter(Boolean);

    if (!urls.length) { callback(); return; }

    var done = 0;
    urls.forEach(function (url) {
      var img = new Image();
      img.onload = img.onerror = function () {
        done++;
        if (done === urls.length) callback();
      };
      img.src = url;
    });
  }

  function handleKeepOnly(keepKey, removeKey) {
    closeModal();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: removeKey, quantity: 0 })
    })
    .then(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
      );
    })
    .catch(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
      );
    });
  }

  function handleDismiss() {
    if (activeDismissKey) {
      try { sessionStorage.setItem(activeDismissKey, '1'); } catch (e) {}
    }
    closeModal();
  }

  function buildModal() {
    var el = document.createElement('div');
    el.id = 'fit-advisor-overlay';
    el.className = 'fit-advisor-overlay';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('role', 'presentation');
    el.innerHTML = [
      '<div class="fit-advisor-modal" role="dialog" aria-modal="true" aria-labelledby="fit-advisor-title">',
        '<button class="fit-advisor-close" id="fit-advisor-close" type="button" aria-label="Luk">',
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">',
            '<path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>',
          '</svg>',
        '</button>',
        '<h2 class="fit-advisor-heading" id="fit-advisor-title">Du er ved at købe to størrelser</h2>',
        '<p class="fit-advisor-body">',
          'Når du bestiller to størrelser, ender den ene typisk med at blive sendt retur.',
          ' Ved kun at beholde én reducerer du både antallet af returneringer og CO₂-udledningen fra forsendelsen.',
        '</p>',
        '<div class="fit-advisor-recommendation" id="fit-advisor-recommendation" hidden>',
          '<div class="fit-advisor-rec-content">',
            '<span class="fit-advisor-rec-label">VORES ANBEFALING</span>',
            '<p class="fit-advisor-rec-text" id="fit-advisor-rec-text"></p>',
          '</div>',
        '</div>',
        '<div class="fit-advisor-cards" id="fit-advisor-cards">',
          '<div class="fit-advisor-card" id="fit-advisor-card-0">',
            '<div class="fit-advisor-card__image-wrap">',
              '<img class="fit-advisor-card__image" id="fit-advisor-img-0" src="" alt="" width="200" height="200">',
            '</div>',
            '<span class="fit-advisor-card__size" id="fit-advisor-size-0"></span>',
            '<button class="fit-advisor-card__keep" id="fit-advisor-keep-0" type="button">Behold kun denne</button>',
          '</div>',
          '<div class="fit-advisor-card" id="fit-advisor-card-1">',
            '<div class="fit-advisor-card__image-wrap">',
              '<img class="fit-advisor-card__image" id="fit-advisor-img-1" src="" alt="" width="200" height="200">',
            '</div>',
            '<span class="fit-advisor-card__size" id="fit-advisor-size-1"></span>',
            '<button class="fit-advisor-card__keep" id="fit-advisor-keep-1" type="button">Behold kun denne</button>',
          '</div>',
        '</div>',
        '<div class="fit-advisor-footer">',
          '<button class="fit-advisor-continue" id="fit-advisor-continue" type="button">Fortsæt med begge</button>',
        '</div>',
      '</div>'
    ].join('');
    return el;
  }

  function ensureInjected() {
    if (isInjected) return true;

    overlay = buildModal();
    document.body.appendChild(overlay);
    isInjected = true;

    modal = overlay.querySelector('.fit-advisor-modal');
    recBox = document.getElementById('fit-advisor-recommendation');
    recText = document.getElementById('fit-advisor-rec-text');
    keepBtns = [
      document.getElementById('fit-advisor-keep-0'),
      document.getElementById('fit-advisor-keep-1')
    ];
    closeBtn = document.getElementById('fit-advisor-close');
    continueBtn = document.getElementById('fit-advisor-continue');

    closeBtn.addEventListener('click', handleDismiss);
    continueBtn.addEventListener('click', handleDismiss);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) handleDismiss();
    });

    return true;
  }

  function detect() {
    if (detecting) return;
    detecting = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        cart.items.forEach(function (item) {
          var pid = String(item.product_id);
          if (!groups[pid]) groups[pid] = [];
          groups[pid].push(item);
        });

        var productData = getProductData();

        var found = false;
        Object.keys(groups).forEach(function (pid) {
          if (found) return;
          var items = groups[pid];

          var seen = {};
          var distinctItems = [];
          items.forEach(function (item) {
            if (!seen[item.variant_id]) {
              seen[item.variant_id] = true;
              distinctItems.push(item);
            }
          });

          if (distinctItems.length < 2) return;

          var displayItems = distinctItems.slice(0, 2);
          var variantIds = displayItems.map(function (i) { return i.variant_id; });
          var key = dismissKey(pid, variantIds);

          try {
            if (sessionStorage.getItem(key)) return;
          } catch (e) {}

          activeDismissKey = key;
          var trueToSize = productData.hasOwnProperty(pid) ? productData[pid] : null;
          found = true;
          preloadImages(displayItems, function () {
            ensureInjected();
            populateModal(displayItems, trueToSize);
            openModal();
          });
        });
      })
      .catch(function () {})
      .then(function () { detecting = false; });
  }

  function init() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.getAttribute('aria-hidden') === 'false') {
        handleDismiss();
      }
    });

    document.addEventListener('theme:cartchanged', function () {
      if (overlay && overlay.getAttribute('aria-hidden') === 'false') return;
      detect();
    });

    detect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
